import { styled } from 'styled-components';
export const Wrapper = styled.div `
  max-width: 400px;
  background-color: ${({ theme }) => theme.colors.black_1};
  display: grid;
  grid-template-columns: auto min-content;
  padding: 16px;
  column-gap: 16px;
  border-radius: 8px;
  align-items: center;
  position: fixed;
  z-index: 1009;
  left: 0;
  right: 0;
  margin: 0 auto;
  bottom: 40px;
`;
export const Title = styled.h2 `
  ${({ theme }) => theme.typography.textLarge};
  ${({ theme }) => theme.typography.weightMedium};
  color: ${({ theme }) => theme.colors.grey00_1};
  margin: 0 0 2px;
`;
export const Text = styled.p `
  ${({ theme }) => theme.typography.textMedium};
  color: ${({ theme }) => theme.colors.grey30_1};
  margin: 0;
`;
